<div id="overlayer"></div>
<div class="sura-loader">
    <div></div>
    <div></div>
</div>